module.exports = "<!-- <block-ui [template]=\"blockUITemplate\"> -->\r\n<block-ui>\r\n  <app-layout>\r\n\r\n  </app-layout>\r\n</block-ui>\r\n"